import type {ReactNode} from "react";

import {Skeleton, cn} from "@project/design-system-web";

export function ToolbarSkeleton({children, className}: {children: ReactNode; className?: string}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 @lg:flex-row @lg:items-end @lg:justify-between",
        className,
      )}
    >
      {children}
    </div>
  );
}

ToolbarSkeleton.Input = function ToolbarInputSkeleton({className}: {className?: string}) {
  return <Skeleton className={cn("h-10 w-full rounded-lg @lg:w-64", className)} />;
};

ToolbarSkeleton.Button = function ToolbarButtonSkeleton({className}: {className?: string}) {
  return <Skeleton className={cn("h-10 w-24 rounded-lg", className)} />;
};

ToolbarSkeleton.Actions = function ToolbarActionsSkeleton({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn("flex items-center gap-2", className)}>{children}</div>;
};
